import { all, call, put, fork, takeEvery, select } from 'redux-saga/effects';
import {
    fetchPortfoliosSuccess,
    showPortfolioMessage,
    onSavePortfolioSuccess,
    onDeletePortfolioSuccess,
    addFavouritePortfolioSuccess,
    onPortfolioDashboardSuccess,
} from 'actions/portfolio';
import {
    ON_SAVE_PORTFOLIO,
    FETCH_ALL_PORTFOLIO,
    ON_DELETE_PORTFOLIO,
    ADD_FAVOURITE_PORTFOLIO,
    ON_PORTFOLIO_DASHBOARD
} from 'constants/ActionTypes';
import { fetchDataRequest, addOrUpdateDataRequest, updateDataRequest, deleteDataRequest  } from 'services/ApiService';
import { apiErrorMessageFormatter } from 'services/errorService';
import { ORGID_PATH_PARAM } from 'constants/api';

const currentOrg = (state) => state.orgs.selectedOrg;
const getPortfolioList = (state) => state.portfolios.allPortfolio;

export function* onPortfolioDashboard({ payload }) {
    // payload is the portfolio id
    try {
        const selectedOrg = yield select(currentOrg);
        const fetchedPortfolio = yield call(
            fetchDataRequest,
            'portfolioDashboard',
            [ORGID_PATH_PARAM, 'portfolioId'],
            [selectedOrg ?.id, payload]
        ) || [];
        yield put(onPortfolioDashboardSuccess(fetchedPortfolio));
    } catch (error) {
        yield put(showPortfolioMessage(apiErrorMessageFormatter(error)));
    }
}

export function* fetchPortfolios() {
    try {
        const selectedOrg = yield select(currentOrg);
        const fetchedPortfolios = yield call(
            fetchDataRequest,
            'portfolios',
            [ORGID_PATH_PARAM],
            [selectedOrg ?.id]
        ) || [];
        yield put(fetchPortfoliosSuccess(fetchedPortfolios));
    } catch (error) {
        yield put(showPortfolioMessage(apiErrorMessageFormatter(error)));
    }
}

export function* deletePortfolio({ payload }) {
    try {
        // payload should be the portfolioId
        const selectedOrg = yield select(currentOrg);
        yield call(
            deleteDataRequest,
            'deletePortfolio',
            'Deleting portfolio '.concat(payload),
            [ORGID_PATH_PARAM, 'portfolioId'],
            [selectedOrg ?.id, payload]
        ) || [];
        yield put(onDeletePortfolioSuccess(payload)); // just dispatch the id as the reducer will remove from the item from the list
    } catch (error) {
        yield put(showPortfolioMessage(apiErrorMessageFormatter(error)));
    }
}

export function* savePortfolio({ payload }) {
    try {
        const selectedOrg = yield select(currentOrg);
        const allPortfolios = yield select(getPortfolioList);
        let finalPayload = { ...payload };
        // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is
        if (payload ?.orgid === '') {
            finalPayload = { ...payload, orgid: selectedOrg ?.id };
        }
        const savedPortfolio = yield call(
            addOrUpdateDataRequest,
            allPortfolios,
            finalPayload,
            'addPortfolio',
            'updatePortfolio',
            [ORGID_PATH_PARAM],
            [selectedOrg.id]);
        yield put(onSavePortfolioSuccess(savedPortfolio));
    } catch (error) {
        yield put(showPortfolioMessage(apiErrorMessageFormatter(error)));
    }
}

/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */
export function* addFavouritePortfolio({ payload }) {
    try {
        const allPortfolios = yield select(getPortfolioList);
        const selectedOrg = yield select(currentOrg);
        const filtered = allPortfolios.filter((entry) => entry ?.id === payload ?.id);

        if (filtered ?.length > 0) {
            const entry = filtered[0];
            const updatedPortfolio = {
                ...entry,
                starred: !payload.starred
            };
            const auditMsg = 'Updating starred setting to '.concat(updatedPortfolio ?.starred).concat(' for portfolio ').concat(updatedPortfolio ?.id);
            yield call(
                updateDataRequest,
                updatedPortfolio,
                'updatePortfolio',
                auditMsg,
                [ORGID_PATH_PARAM],
                [selectedOrg.id],
            );
            // now just pass on the original payload as the reducer will filter the list as per the state of the selection
            yield put(addFavouritePortfolioSuccess(payload));
        }
    } catch (error) {
        yield put(showPortfolioMessage(error.messages));
    }
}

export function* fetchPortfoliosSaga() {
    yield takeEvery(FETCH_ALL_PORTFOLIO, fetchPortfolios);
}

export function* savePortfolioSaga() {
    yield takeEvery(ON_SAVE_PORTFOLIO, savePortfolio);
}

export function* deletePortfolioSaga() {
    yield takeEvery(ON_DELETE_PORTFOLIO, deletePortfolio);
}

export function* addFavouritePortfolioSaga() {
    yield takeEvery(ADD_FAVOURITE_PORTFOLIO, addFavouritePortfolio);
}

export function* onPortfolioDashboardSaga() {
    yield takeEvery(ON_PORTFOLIO_DASHBOARD, onPortfolioDashboard);
}

export default function* rootSaga() {
    yield all([
        fork(fetchPortfoliosSaga),
        fork(savePortfolioSaga),
        fork(deletePortfolioSaga),
        fork(addFavouritePortfolioSaga),
        fork(onPortfolioDashboardSaga),
    ]);
}


// WEBPACK FOOTER //
// ./sagas/portfolio.js